export const sectionPhaseSx = (unlocked: boolean) => ({
  mb: 3,
  transition:
    'opacity 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1)',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    transform: 'none',
  },
  opacity: unlocked ? 1 : 0.48,
  transform: unlocked ? 'translateY(0)' : 'translateY(4px)',
  pointerEvents: unlocked ? ('auto' as const) : ('none' as const),
});
